/* ============================================================
   SUIS "TIKTOK CHECKS" — Music copyright check + Content check lite
   (2026-10-13, keputusan user: pelanggan pilih sendiri di Control Panel; LALAI HIDUP)

   Per-BROWSER (localStorage), sama seperti suis AI label / beg kuning — pelanggan
   memakai beberapa browser serentak dan setiap satu boleh berbeza.

   Laluan ke robot: `tetapanSemakanTiktok()` dibaca SEMASA payload dibina dan
   dimasukkan ke kotak terbuka `tetapan` pada KEDUA-DUA laluan Run TikTok
   (WorkspaceView: kalendar + lama). `tetapan` dihantar bulat-bulat oleh
   content.ts + background.ts, jadi TIADA ZIP diperlukan.

   ⚠️ KEMBAR: nama medan `semakMuzik` / `semakKandungan` dibaca oleh robot
   `tiktok-automation.js` (`_ttAturSuisSemakan`). Tukar di satu tempat = tukar
   di kedua-duanya. Robot menganggap medan TIADA = HIDUP.
   ============================================================ */

export const KUNCI_SEMAK_MUZIK = 'sesaat_tt_semak_muzik_v1';
export const KUNCI_SEMAK_KANDUNGAN = 'sesaat_tt_semak_kandungan_v1';

/* '0' = MATI. Apa-apa selain itu (termasuk tiada / storan ditutup) = HIDUP. */
function bacaSatu(kunci) {
  try { return localStorage.getItem(kunci) !== '0'; } catch { return true; }
}

export function bacaSemakanTiktok() {
  return { muzik: bacaSatu(KUNCI_SEMAK_MUZIK), kandungan: bacaSatu(KUNCI_SEMAK_KANDUNGAN) };
}

/* Pulang true bila berjaya disimpan — pemanggil boleh memberitahu pelanggan bila gagal. */
export function tulisSemakanTiktok(jenis, hidup) {
  const kunci = jenis === 'muzik' ? KUNCI_SEMAK_MUZIK : jenis === 'kandungan' ? KUNCI_SEMAK_KANDUNGAN : '';
  if (!kunci) return false;
  try { localStorage.setItem(kunci, hidup ? '1' : '0'); return true; } catch { return false; }
}

/* Medan untuk kotak `tetapan` payload Run TikTok. Sentiasa boolean. */
export function tetapanSemakanTiktok() {
  const s = bacaSemakanTiktok();
  return { semakMuzik: s.muzik === true, semakKandungan: s.kandungan === true };
}
